export default __webpack_public_path__ + "518fbb9dc8bfeaf00b604e64c2624444.obj";